import { render } from "./hoverEffect10.vue?vue&type=template&id=3b49688e"
import script from "./hoverEffect10.vue?vue&type=script&lang=js"
export * from "./hoverEffect10.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__